document.querySelectorAll('.disclosure-button').forEach(button => {
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    const contentId = button.getAttribute('aria-controls');
    const content = document.getElementById(contentId);

    button.setAttribute('aria-expanded', !expanded);
    content.hidden = expanded;
  });
});